"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useBool = (initialState = false) => {
    const [state, setState] = react_1.useState(initialState);
    const handlers = react_1.useMemo(() => ({
        setTrue: () => setState(true),
        setFalse: () => setState(false),
        toggle: () => setState(s => !s),
        reset: () => setState(initialState),
        setCustom: value => setState(value)
    }), [initialState]);
    return [state, handlers];
};
exports.default = useBool;
